import styled from "styled-components";

export const IconContainer = styled.div`
  padding: 0;
  font-size: 14px;
  border-width: 0px;
  border-radius: 5px;
  transition: background-color 0.2s, box-shadow 0.2s;
  width: auto;
  display: flex;
  flex-direction: row;
`;

export const Icon = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.08);
  min-width: 31px;
  min-height: 31px;
  padding: 5px 10px;

  display: flex;
  justify-content: center;

  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
`;
